import { Box, Button } from '@mui/material';
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getMissions } from 'src/api/apis';
import { TokenExpiredError } from 'src/api/error';
import MissionCard from 'src/components/Card/MissionCard';
import SearchInput from 'src/components/Input/SearchInput';
import PageLayout from 'src/components/Layout/PageLayout';
import { ROUTES } from 'src/utils/constant';

import { useTranslation } from 'react-i18next';

export default function MissionReportList () {
  const { t } = useTranslation();
  const history = useHistory();
  const [search, setSearch] = useState('');
  const [missions, setMissions] = useState([]);

  const showMissions = missions.filter(mission => mission.title.en.includes(search));

  const getMissionList = () => {
    getMissions()
      .then(response => {
        if (response.data.status === '1') setMissions(response.data.mission);
      })
      .catch(err => {
        if (err instanceof TokenExpiredError) {
          history.push(ROUTES.login);
        }
      });
  };

  useEffect(() => {
    getMissionList();
  }, []);

  return (
    <PageLayout
      topRight={
        <div style={{ display: 'flex', gap: '20px' }}>
          <SearchInput onTextChange={text => { setSearch(text); }} />
          <Button variant="contained">{t('Export')}</Button>
        </div>
      }
      title="Mission Report"
      arrow="left"
      isAdmin={true}
      onTitleClick={() => { history.push(ROUTES.courseReportList); }}
      report
    >
      <Box sx={{ paddingTop: '30px' }}>
        {showMissions.map(mission => (
          <MissionCard mission={mission} key={mission.id} report />
        ))}
      </Box>
    </PageLayout>
  );
}
